var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from "styled-components";
import { Para } from "@irati/ui/src/Labels";
import Link from "@irati/ui/src/Link";
import { minWidthMedia } from "@irati/ui/src/global/media";
import { greys } from "@irati/ui/src/global/colors";
export var Wrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin-top: ", ";\n"], ["\n  margin-top: ", ";\n"])), function (_a) {
    var isMarginLarge = _a.isMarginLarge;
    return (isMarginLarge ? "60px" : "20px");
});
export var StyledLink = styled(Link)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  ", "\n  display: inline-block;\n  font-size: 12px;\n  ", "\n"], ["\n  ", "\n  display: inline-block;\n  font-size: 12px;\n  ",
    "\n"])), function (_a) {
    var isGrey = _a.isGrey;
    return isGrey && "color: " + greys.medium + ";";
}, minWidthMedia.tablet(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    font-size: 14px;\n  "], ["\n    font-size: 14px;\n  "]))));
export var InlinePara = styled(Para)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  ", "\n  display: inline;\n"], ["\n  ", "\n  display: inline;\n"])), function (_a) {
    var isGrey = _a.isGrey;
    return isGrey && "color: " + greys.medium + ";";
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
